import type { ErrorEventHandler, FeatureInitEventHandler } from './types'

export let onError: ErrorEventHandler | null = null

export function setOnError(handler: ErrorEventHandler) {
  onError = handler
}
export let onFeatureInit: FeatureInitEventHandler = null

export function setOnFeatureInit(handler: FeatureInitEventHandler) {
  onFeatureInit = handler
}
